import axios from "axios";
import { toast } from "react-toastify";

let is403Error = false;

const axiosInstance = axios.create({
    baseURL: process.env.REACT_APP_DIAGNOSTIC_BASEURL,
    headers: {
        "Content-type": "application/json",
    }
});

const navigateToLogin = () => {
    localStorage.clear();
    if (globalThis?.window) {
        globalThis.location.href = "/";
    }};

axiosInstance.interceptors.request.use(
    (config) => {
        const token = localStorage.getItem('access_token');
        if (!config.headers.Authorization && token) {
            config.headers.Authorization = `Bearer ${token}`;
        }
        return config;
    },
    (error) => Promise.reject(error)
);

axiosInstance.interceptors.response.use(
    (response) => response,
    (error) => {
        if (error.response?.status === 403 && !is403Error) {
            is403Error = true;
            toast.warn("Your session has ended. Please log in again to continue.", {
                position: toast.POSITION.TOP_CENTER,
                onClose: navigateToLogin,
            });
        }
        return Promise.reject(error);
    }
);

export default axiosInstance;